import Form from "sap/ui/layout/form/Form";
import Device from "sap/ui/Device";
import ResponsiveGridLayout from "sap/ui/layout/form/ResponsiveGridLayout";
import FormContainer from "sap/ui/layout/form/FormContainer";
import FormElement from "sap/ui/layout/form/FormElement";
import Label from "sap/m/Label";

export default class TrimWhiteSpaceForm extends Form {

  private _bResizeHandlerAttached: boolean = false;

  public onAfterRendering(oEvent: jQuery.Event): void | undefined {
    super.onAfterRendering(oEvent);

    if (!this._bResizeHandlerAttached) {
      Device.resize.attachHandler(() => {
        this.rerender();
        this.runResize();
      }, this);
      this._bResizeHandlerAttached = true;
    }

    this.runResize();
  }

  private runResize(): void {
    const iBreakpoint = this.getBreakpoint();
    const arContainerGroups = this.groupContainers(this.getFormContainers(), iBreakpoint);

    for (const arContainers of arContainerGroups) {
      const oTrims = this.calculateContainerTrim(arContainers) as ContainerTrim;
      for (const oContainer of arContainers) {
        this.applyTrim(oContainer, oTrims);
      }
    }
  }

  private getBreakpoint(): int {
    const oLayout = this.getLayout() as ResponsiveGridLayout;
    const element = this.getDomRef() as HTMLElement;
    const iWindowWidth = element?.offsetWidth;
    if(!oLayout) {
        return 1;
    }
    if (iWindowWidth > oLayout.getBreakpointXL()) {
      if (oLayout.getColumnsXL() === -1) {
        return oLayout.getColumnsL();
      }
      return oLayout.getColumnsXL();
    } else if (iWindowWidth > oLayout.getBreakpointL()) {
      return oLayout.getColumnsL();
    } else if (iWindowWidth > oLayout.getBreakpointM()) {
      return oLayout.getColumnsM();
    } else {
      return 1;
    }
  }

  private groupContainers(arContainers: FormContainer[], iBreakpoint: int): FormContainer[][] {
    const arContainerGroups = Array.from({ length: iBreakpoint }, (): FormContainer[] => []);
    for (let i = 0; i < arContainers.length; i++) {
      arContainerGroups[i % iBreakpoint].push(arContainers[i]);
    }

    return arContainerGroups;
  }

  private calculateContainerTrim(arContainers: FormContainer[]): ContainerTrim {
    const oTrims = new ContainerTrim();
    let iOriginalLabelSize = 0;
    for (const oContainer of arContainers) {
      const arElements = oContainer.getFormElements();

      const arLabelSizes = arElements.map((oElement) => {
        return (this.getLabelDom(oElement)?.firstChild.firstChild as HTMLElement)?.offsetWidth;
      });

      const iMaxLabelSize = Math.max(...arLabelSizes) + 20;
      oTrims.labels = Math.max(oTrims.labels, iMaxLabelSize);
      iOriginalLabelSize = this.getLabelDom(arElements[0])?.offsetWidth;
    }

    if (iOriginalLabelSize === 0) {
      oTrims.labels = 0;
    } else {
      const iLabelDelta = iOriginalLabelSize - oTrims.labels;
      oTrims.labels = iLabelDelta < 0 ? 0 : iLabelDelta;
      oTrims.container = oTrims.labels + oTrims.fields;
    }
    return oTrims;
  }


  private getLabelDom(formElement: FormElement): HTMLElement | null {

    const oLabel = formElement.getLabel();

    if (typeof oLabel === 'string') {
      return null;
    }
    let domElement = (oLabel as Label).getDomRef();
    return domElement as HTMLElement | null;
  }


  private applyTrim(oContainer: FormContainer, oTrims: ContainerTrim): void {
    const arElements = oContainer.getFormElements();
    if (oTrims.labels === 0) {
      return;
    }
    for (const element of arElements) {
      const oNode = this.getLabelDom(element);
      if (!oNode) {
        return;
      }
      let parentElement = oNode.parentNode as HTMLElement;
      parentElement.style.width = parentElement.offsetWidth - oTrims.labels + "px";
    }

    const oNode = oContainer.getDomRef() as HTMLElement;
    if (!oNode) {
      return;
    }

    let parentElement = oNode.parentNode as HTMLElement;
    parentElement.style.width = parentElement.offsetWidth - oTrims.container + "px";
    oNode.style.width = oNode.offsetWidth + oTrims.container + "px";
  }
}

class ContainerTrim {
  labels: int = 0;
  fields: int = 0;
  container: int = 0;
}